export enum eHDPath
{
    BIP_44 = 'm/44\'/60\'/0\'/0/{account_index}',
    LEDGER_LIVE = 'm/44\'/60\'/{account_index}\'/0/0',
    LEDGER_LEGACY = '44\'/60\'/0\'/{account_index}'
}

interface IHDPathSpecificationItem
{
    name: string;
    path: (typeof eHDPath)[ keyof typeof eHDPath ];
}

interface IHDPathSpecification
{
    BIP_44: IHDPathSpecificationItem;
    LEDGER_LIVE: IHDPathSpecificationItem;
    LEDGER_LEGACY: IHDPathSpecificationItem;
}

export const HDPathSpecification: IHDPathSpecification = {
    BIP_44: {
        name: 'BIP-44',
        path: eHDPath.BIP_44,
    },
    LEDGER_LIVE: {
        name: 'LedgerLive',
        path: eHDPath.LEDGER_LIVE,
    },
    LEDGER_LEGACY: {
        name: 'LedgerLegacy',
        path: eHDPath.LEDGER_LEGACY,
    },
};

type eHDPathValue = (typeof eHDPath)[ keyof typeof eHDPath ];

export const hdPathGenerate = (hdPath: eHDPathValue, index: number): string =>
{
    return hdPath.replace('{account_index}', String(index));
};

export const hdPathGetIndex = (hdPath: string): string | null =>
{
    if (!hdPath)
    {
        return null;
    }

    const path = hdPath.split('/');
    const lastValue = path[ path.length - 1 ];
    if (lastValue)
    {
        return lastValue;
    }
    return null;
};

export const hdPathGetUIIndex = (hdPath: string): number | null =>
{
    if (!hdPath)
    {
        return null;
    }

    const path = hdPath.split('/');
    const lastValue = path[ path.length - 1 ];
    if (lastValue)
    {
        return Number(lastValue) + 1;
    }
    return null;
};

export const hdPathFindMaxIndex = <T>(wallets: T[], hdPathKey: keyof T): number =>
{
    const pathIndexes = wallets
        .filter(wallet => wallet[ hdPathKey ])
        .map(wallet => Number(hdPathGetIndex(wallet[ hdPathKey ] as unknown as string)));
    if (pathIndexes.length)
    {
        return Math.max(...pathIndexes);
    }
    return 0;
};

export const hdPathReplaceQuotes = (path: string): string =>
{
    const singleQuoteReg = /'/g;
    let result = '';
    for (const char of path)
    {
        const singleQuote = new RegExp(singleQuoteReg);
        if (singleQuote.test(char))
        {
            result = path.replace(singleQuoteReg, '\'\'');
        }
    }
    return result;
};
